<template>
  <div>
    <sticky v-if="origin" class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title" v-if="parent">Edition d'une Sous-Origine</span>
      <span slot="left-title" v-else>Edition d'une Origine</span>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="columns is-gapless is-padding-left-on-btn-actions is-padding-right-on-btn-actions is-padding-top" v-if="origin && !loading">
      <div class="column is-12 is-8-widescreen is-7-fullhd">
        <div class="has-bg-white is-border">
          <origin-form :source="origin" :parent="parent" @failed="submitFailed"
                 @submit="submit" :loading="loading"></origin-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import OriginForm from '@/components/origin/OriginForm'

  export default {
    name: 'OriginEdit',
    components: {
      OriginForm
    },
    data () {
      return {
        loading: false,
        origin: null,
        parent: null
      }
    },
    computed: {
    },
    methods: {
      submitFailed (origin) {
        console.log('error with origin > ', origin)
      },
      submit (origin) {
        this.loading = true
        this.$api.originService.put(origin.pk, origin).then(res => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Mise à jour effectuée.'
          })
          if (origin.parent) {
            this.$router.push({name: 'OriginVue', params: {id: origin.parent}})
          } else {
            this.$router.push({name: 'OriginVue', params: {id: origin.pk}})
          }
        }).catch(err => {
          this.loading = false
          console.log(err)
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'enregistrement.'
          })
        })
      },
      getOrigin (id) {
        this.loading = true
        this.$api.originService.getOne(id).then(res => {
          this.origin = res.data
          if (this.origin.parent) {
            this.getParentOrigin(this.origin.parent)
          } else {
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        })
      },
      getParentOrigin (parentPk) {
        this.loading = true
        this.$api.originService.getOne(parentPk)
          .then(res => {
            this.parent = res.data
            this.loading = false
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    created () {
      this.getOrigin(this.$route.params.id)
      if (this.$route.query.parent) {
        this.getParentOrigin(this.$route.query.parent)
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/origin/OriginEdit.vue